module.exports = __webpack_public_path__ + "img/1724032227067-semprong isan hakim.jpg.daed4d93.webp";